import { Breadcrumb, Button } from '@fukuri-admins/ui/common';
import { FieldWrapper } from '@fukuri-admins/ui/common/Form/FieldWrapper';
import { DatePicker } from '@fukuri-admins/ui/common/Form/FormItems/DatePicker';
import { BREADCRUMB_ITEMS } from '../constants';
import styles from './styles.module.scss';

type Props = {
  /** 従業員数 */
  userCount: number;
  /** 回答期限 */
  deadline?: Date;
  /** 回答期限変更ハンドラー */
  onDeadlineChange: (value: Date | undefined) => void;
  /** 送信ハンドラー */
  onSubmit: () => void;
  /** 戻るハンドラー */
  onBack: () => void;
  /** 送信ボタンの無効化状態 */
  isButtonDisabled: boolean;
};

export const CreateStressAssessmentPresentation: React.FC<Props> = ({
  userCount,
  deadline,
  onDeadlineChange,
  onSubmit,
  onBack,
  isButtonDisabled,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.breadcrumbWrapper}>
        <Breadcrumb items={BREADCRUMB_ITEMS} />
      </div>

      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>ストレスチェックの実施</h2>
        <div className={styles.content}>
          <div className={styles.field}>
            <label className={styles.label}>従業員数</label>
            <p className={styles.value}>{userCount}人</p>
          </div>

          <FieldWrapper htmlFor='deadline' labelType='required' labelText='回答期間'>
            <DatePicker value={deadline} onChange={onDeadlineChange} fromDate={new Date()} />
          </FieldWrapper>
        </div>
      </div>

      <div className={styles.actions}>
        <Button onClick={onBack} variant='outline'>
          前へ戻る
        </Button>
        <Button onClick={onSubmit} disabled={isButtonDisabled}>
          送信
        </Button>
      </div>
    </div>
  );
};
